// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS
export const FETCH_DYEING_DC_DETAILS_REQUEST_DK = 'FETCH_DYEING_DC_DETAILS_REQUEST_DK';
export const FETCH_DYEING_DC_DETAILS_SUCCESS_DK = 'FETCH_DYEING_DC_DETAILS_SUCCESS_DK';
export const FETCH_DYEING_DC_DETAILS_FAILURE_DK = 'FETCH_DYEING_DC_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS
export const FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK = 'FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_REQUEST_DK';
export const FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK = 'FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_SUCCESS_DK';
export const FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK = 'FETCH_DYEING_DC_DETAILS_PROGRAM_LIST_FAILURE_DK';

export const FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST_DK = 'FETCH_GRN_NO_BY_DYEING_DC_NO_REQUEST_DK';
export const FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS_DK = 'FETCH_GRN_NO_BY_DYEING_DC_NO_SUCCESS_DK';
export const FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE_DK = 'FETCH_GRN_NO_BY_DYEING_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS
export const FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST_DK = 'FETCH_DYEING_DC_DETAILS_DC_NO_REQUEST_DK';
export const FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS_DK = 'FETCH_DYEING_DC_DETAILS_DC_NO_SUCCESS_DK';
export const FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE_DK = 'FETCH_DYEING_DC_DETAILS_DC_NO_FAILURE_DK';

// FETCH ALL PROPERTIES FROM DYEING_DC DETAILS BY ID
export const FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST_DK = 'FETCH_DYEING_DC_DETAILS_BY_ID_REQUEST_DK';
export const FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS_DK = 'FETCH_DYEING_DC_DETAILS_BY_ID_SUCCESS_DK';
export const FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE_DK = 'FETCH_DYEING_DC_DETAILS_BY_ID_FAILURE_DK';

// CREATE PROPERTIES FOR DYEING_DC DETAILS
export const CREATE_DYEING_DC_DETAILS_REQUEST_DK = 'CREATE_DYEING_DC_DETAILS_REQUEST_DK';
export const CREATE_DYEING_DC_DETAILS_SUCCESS_DK = 'CREATE_DYEING_DC_DETAILS_SUCCESS_DK';
export const CREATE_DYEING_DC_DETAILS_FAILURE_DK = 'CREATE_DYEING_DC_DETAILS_FAILURE_DK';

//CREATE USER FORM
export const CREATE_USER_FORM_DYEING_DC_DETAILS_DK = 'CREATE_USER_FORM_DYEING_DC_DETAILS_DK';

// UPDATE PROPERTIES FOR DYEING_DC DETAILS
export const UPDATE_DYEING_DC_DETAILS_REQUEST_DK = 'UPDATE_DYEING_DC_DETAILS_REQUEST_DK';
export const UPDATE_DYEING_DC_DETAILS_SUCCESS_DK = 'UPDATE_DYEING_DC_DETAILS_SUCCESS_DK';
export const UPDATE_DYEING_DC_DETAILS_FAILURE_DK = 'UPDATE_DYEING_DC_DETAILS_FAILURE_DK';

// FETCH SINGLE DYEING_DC_DETAILS
export const FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST_DK = 'FETCH_SINGLE_DYEING_DC_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_DYEING_DC_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE_DK = 'FETCH_SINGLE_DYEING_DC_DETAILS_FAILURE_DK';

// DELETE PROPERTIES FOR DYEING_DC DETAILS
export const DELETE_DYEING_DC_DETAILS_REQUEST_DK = 'DELETE_DYEING_DC_DETAILS_REQUEST_DK';
export const DELETE_DYEING_DC_DETAILS_SUCCESS_DK = 'DELETE_DYEING_DC_DETAILS_SUCCESS_DK';
export const DELETE_DYEING_DC_DETAILS_FAILURE_DK = 'DELETE_DYEING_DC_DETAILS_FAILURE_DK';

export const FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST_DK = 'FETCH_DYEING_DC_PREVIOUS_LIST_REQUEST_DK';
export const FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS_DK = 'FETCH_DYEING_DC_PREVIOUS_LIST_SUCCESS_DK';
export const FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE_DK = 'FETCH_DYEING_DC_PREVIOUS_LIST_FAILURE_DK';

// USERFORM RESET

export const DYEING_DC_DETAILS_USERFORM_RESET_DK = 'DYEING_DC_DETAILS_USERFORM_RESET_DK';

export const DYEING_CLOSE_BTN_POST_REQUEST = 'DYEING_CLOSE_BTN_POST_REQUEST'
export const DYEING_CLOSE_BTN_POST_SUCCESS = 'DYEING_CLOSE_BTN_POST_SUCCESS'
export const DYEING_CLOSE_BTN_POST_FALIURE = 'DYEING_CLOSE_BTN_POST_FALIURE'



export const DYEING_CHECK_ALL_UPDATE_REQUEST = 'DYEING_CHECK_ALL_UPDATE_REQUEST'
export const DYEING_CHECK_ALL_UPDATE_SUCCESS = 'DYEING_CHECK_ALL_UPDATE_SUCCESS'
export const DYEING_CHECK_ALL_UPDATE_FALIURE = 'DYEING_CHECK_ALL_UPDATE_FALIURE'